import * as React from 'react';
import icon from './booket-app-icon.svg';
import logo from './logo.svg';

export const BooketLogo = (props: any) => <img alt="" src={logo} {...props} />;

export const BooketIcon = (props: any) => <img alt="" src={icon} {...props} />;

export default BooketLogo;
